/**
 * Dynamic query for marketplace_features with filtering support
 */
const featuresQuery = `
query MarketplaceFeatures($first: Int!, $skip: Int, $where: Marketplace_featureWhereInput, $order: [Marketplace_featureOrder!]) {
  marketplace_features(
    first: $first,
    skip: $skip,
    where: $where,
    order: $order
  ) {
    count
    edges {
      node {
        objectId
        name
        label
        description
        plans { ... on Element { value } }
        createdAt
        updatedAt
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default featuresQuery;
